import { DiscoveryFeature } from '@utils/shouldShowDiscoveryCard';

const key = (feature: DiscoveryFeature) => `discovery-card-dismissed-${feature}`;

export const getDiscoveryCardDismissal = (
  feature: DiscoveryFeature,
): number | null => {
  const stored = localStorage.getItem(key(feature));
  const parsed = Number(stored);

  return stored && Number.isFinite(parsed) ? parsed : null;
};

export const dismissDiscoveryCard = (feature: DiscoveryFeature) => {
  localStorage.setItem(key(feature), String(Date.now()));
};
